import { Center } from '@zorro/web/design-system';

import { SVGIconProps } from '../types';

export const CardChipIcon = ({ style }: SVGIconProps) => (
  <Center style={style}>
    <svg viewBox="0 0 53 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="0.213"
        y="0.213"
        width="52.447"
        height="34.32"
        rx="4"
        fill="url(#chip-grad)"
        stroke="#3C0789"
        strokeWidth="0.427"
        opacity="0.9"
      />
      <path
        d="M35.6564 -7.33087e-07L35.6564 6.92868C35.6564 7.37069 35.5864 7.80991 35.4489 8.23L34.0727 12.4356M34.0727 12.4356L34.0727 22.8841M34.0727 12.4356L52.0574 12.4356M34.0727 22.8841L35.421 26.7314C35.5768 27.1761 35.6564 27.644 35.6564 28.1153L35.6564 34.7429M34.0727 22.8841L52.0574 22.8842M15.9732 -1.61288e-06L15.9732 6.68359C15.9732 7.28473 16.1027 7.8788 16.353 8.42537L18.2868 12.6494M18.2868 12.6494L18.2868 18.6999C18.2868 21.0108 16.4135 22.8841 14.1026 22.8841L8.26394e-05 22.8841M18.2868 12.6494L8.30724e-05 12.6494M15.9732 27.4033L15.9732 34.7429"
        stroke="#3C0789"
        strokeWidth="0.427188"
      />
      <defs>
        <radialGradient
          id="chip-grad"
          gradientUnits="userSpaceOnUse"
          cx="0"
          cy="0"
          r="10"
          gradientTransform="matrix(4.03 8.08 -65.2 133.4 6.88 3.04)"
        >
          <stop stopColor="#E0E3FE" />
          <stop offset="1" stopColor="#EDEFF6" />
        </radialGradient>
      </defs>
    </svg>
  </Center>
);
